import { IdealAnswerItem } from '../types'

export const convertObjectToString = (obj: Record<string, number>): string => {
  let newString = ''
  Object.keys(obj).forEach(keyword => {
    newString = newString + `${keyword} = ${obj[keyword]}, `
  })
  return newString
}

export const convertStringToObject = (str: string): Record<string, number> => {
  const allKeywords = str.split(',')
  const temp: Record<string, number> = {}

  allKeywords.forEach(item => {
    if (!item.trim().length) {
      return
    }
    const keywordWithScore = item.split('=')
    if (keywordWithScore[0]) {
      temp[keywordWithScore[0].trim()] = keywordWithScore[1]
        ? Number(keywordWithScore[1].trim())
        : 1
    }
  })

  return temp
}

export const convertToBulletFormat = (
  data: IdealAnswerItem[],
): IdealAnswerItem[] => {
  return data.map(item => ({
    ...item,
    keyword_scores:
      typeof item.keyword_scores === 'object'
        ? convertObjectToString(item.keyword_scores)
        : item.keyword_scores,
  }))
}

export const transformIdealAnswerItems = (
  idealAnswerItems: IdealAnswerItem[],
  scoredBy: string,
): IdealAnswerItem[] => {
  return idealAnswerItems.map(item => ({
    ...item,
    keyword_scores:
      typeof item.keyword_scores === 'string'
        ? convertStringToObject(item.keyword_scores)
        : item.keyword_scores,
    score: 'score' in item ? Number(item.score) : 1,
    scored_by: scoredBy,
  }))
}

export const convertTableToKeywords = (
  keywordsData: any[][],
): Record<string, number> => {
  const data: Record<string, number> = {}
  keywordsData?.forEach((row: any[]) => {
    data[row[0]] = parseFloat(row[1])
  })
  return data
}

export const convertKeywordsToTable = (
  data: Record<string, number>,
): any[][] => {
  const temp: any[][] = []
  if (data) {
    Object.keys(data).forEach(keyword => {
      temp.push([keyword, data[keyword]])
    })
  }
  return temp
}

export const divideArray = (data: any[], columnCount: number): any[][] => {
  const temp = [...data]
  if (temp.length > 0) {
    const result = new Array(Math.ceil(temp.length / columnCount))
      .fill(null)
      .map(_ => temp.splice(0, columnCount))
    return result
  }
  return []
}
